var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('secondary-header-component',{class:{'slide-top': _vm.loading}},[_vm._v("Open Source")]),_c('secondary-sub-component',{class:{'slide-top': _vm.loading}},[_vm._v("These are my favorite projects I've worked on for the past few years.")]),_c('open-source-component')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }